import { render } from "./SidebarMenuItemCounter.vue?vue&type=template&id=fb17b698&scoped=true"
import script from "./SidebarMenuItemCounter.vue?vue&type=script&lang=js"
export * from "./SidebarMenuItemCounter.vue?vue&type=script&lang=js"

import "./SidebarMenuItemCounter.vue?vue&type=style&index=0&id=fb17b698&scoped=true&lang=scss"

import exportComponent from "/home/tachyon/wardrobe-test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb17b698"]])

export default __exports__